import React from 'react';

import styles from '../../index.module.scss';

type TimeColumnProps = {
  time: string;
};

export const TimeColumn: React.FC<TimeColumnProps> = ({ time }) => {
  return (
    <td className={styles.timeTd}>
      {time !== '03:00' && <div className={styles.time}>{time}</div>}
    </td>
  );
};
